/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { request } from '@mairistem/tools';
import { useEntiteStore, useParametresStore } from '@/zustand';
import {
  baseUrlApp,
  getDefaultSignataire,
  getSignataires,
  getUserParametrage,
} from '@/routes';
import type { ApiResponse, Individu, Parametre } from '@/types';

interface ParametresZustandProviderProps {
  children: React.ReactNode;
}

const ParametresZustandProvider = (props: ParametresZustandProviderProps) => {
  const { children } = props;

  const entiteSelected = useEntiteStore((state) => state.selectedEntite);
  const parametresUser = useParametresStore((state) => state.parametresUser);
  const setParametresUser = useParametresStore(
    (state) => state.setParametresUser,
  );
  const signataires = useParametresStore((state) => state.signataires);
  const setSignataires = useParametresStore((state) => state.setSignataires);
  const defaultSignataire = useParametresStore(
    (state) => state.defaultSignataire,
  );
  const setDefaultSignataire = useParametresStore(
    (state) => state.setDefaultSignataire,
  );

  const history = useHistory();

  React.useEffect(() => {
    if (_.isNil(parametresUser) && !_.isNil(entiteSelected)) {
      request
        .get(getUserParametrage())
        .then(({ data }: ApiResponse<Parametre>) => {
          const parametreUser: Parametre = data?.[0] || null;
          setParametresUser(parametreUser);
          if (_.isNil(parametreUser)) {
            history.push(`${baseUrlApp}/parametres`);
          }
        });
    }
    if (
      _.isNil(defaultSignataire) &&
      !_.isNil(parametresUser) &&
      !_.isNil(entiteSelected)
    ) {
      request.get(getDefaultSignataire()).then((response: any) => {
        setDefaultSignataire(response);
      });
    }

    if (
      _.isNil(signataires) &&
      !_.isNil(parametresUser) &&
      !_.isNil(entiteSelected)
    ) {
      request
        .get(getSignataires())
        .then(({ data }: ApiResponse<Partial<Individu>[]>) => {
          setSignataires(data?.[0] || null);
        });
    }
  }, [
    defaultSignataire,
    entiteSelected,
    history,
    parametresUser,
    setDefaultSignataire,
    setParametresUser,
    setSignataires,
    signataires,
  ]);

  React.useEffect(() => {
    const xLogin = parametresUser?.identifiant;

    const interceptor = request.interceptors.request.use((config) => {
      // eslint-disable-next-line no-param-reassign
      config.headers['X-Login'] = xLogin || 2; // TEMPORAIRE -> REMPLACER PAR xLogin

      return config;
    });

    return () => {
      request.interceptors.request.eject(interceptor);
    };
  }, [parametresUser]);

  return children;
};

export default ParametresZustandProvider;
